<template>
  <el-dialog :visible.sync="visible" width="450px">
    <template #title>
      <div
        style="font-size: 18px; color: #303133; font-weight: bold; text-align: center;"
      >
        批量发送短信
      </div>
    </template>
    <el-alert :title="prompt" :closable="false" type="error"> </el-alert>

    <el-form
      :model="form"
      :rules="rules"
      label-width="25%"
      ref="formRef"
      size="mini"
      style="width: 100%; margin: 0 auto; margin-top: 20px;"
    >
      <el-form-item v-for="(item, index) in formList" :key="index" :label="item.label" :prop="item.prop">
        <template v-if="item.type === 'select'">
          <el-select v-model="form[item.prop]" style="width: 100%;">
            <el-option
              v-for="val in item.options"
              :key="val.value"
              :label="val.label"
              :value="val.value"
            ></el-option>
          </el-select>
        </template>
        <template v-else-if="item.type === 'model'">
          <input-model v-model="form[item.prop]"></input-model>
        </template>
        <template v-else>
          <el-input v-model="form[item.prop]" style="width: 100%;" :disabled="item.disabled"></el-input>
        </template>
      </el-form-item>
      <!--  -->
    </el-form>

    <template #footer>
      <div class="d-c-c d-r">
        <el-button @click="cancel" size="mini">取消</el-button>
        <el-button type="primary" @click="submit" size="mini">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import InputModel from './unit/InputModel.vue';

const options = [
  { label: "test", value: "test" },
  { label: "test2", value: "test2" },
  { label: "test3", value: "test3" },
  { label: "test4", value: "test4" }
];
const rules = {
  temp: [
    { required: true, message: "*请选择", trigger: "change" }
  ]
};

const formList = [
  { label: "逾期天数:", prop: "temp1", type: "model", disabled: false  },
  { label: "逾期金额:", prop: "temp1", type: "model", disabled: false  },
  { label: "案件状态:", prop: "temp2", type: "select", options },
  { label: "手机号类型:", prop: "temp", type: "select", options },
  { label: "短信模板:", prop: "temp", type: "select", options },
  { label: "逾期天数:", prop: "temp2", type: "input", disabled: true  },
];

const form = { temp: "", temp2: "1", temp1: {start: "", end: ""} };
const baseData = { formList, form, rules, visible: false };
baseData.prompt = '提示：逾期天数，逾期金额，案件状态至少一个有值';

export default {
  name: "buyModel",
  props: {},
  components: { InputModel },
  data() {
    return { ...baseData };
  },
  methods: {
    init: function(data) {
      this.visible = true;
    },
    cancel: function() {
      this.visible = false;
    },
    submit: function() {
      console.log(this.form, "submit");
      this.$refs.formRef.validate(valid => {
        if (valid) {
          return false;
          // this.$emit("submit", this.form);
          // this.visible = false;
        } else return false;
      });
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/views/collection/collection_cases/component/BatchSendModel.vue